import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  DeleteTaskCommentDocument,
  type DeleteTaskCommentMutationVariables,
} from '@/graphql/generated/graphql';

export type DeleteTaskCommentVariables = DeleteTaskCommentMutationVariables;

export const useDeleteTaskComment = () => {
  const mutation = useMutation({
    mutationKey: ['delete-task-comment'],
    mutationFn: (variables: DeleteTaskCommentMutationVariables) =>
      graphqlClient.request(DeleteTaskCommentDocument, variables),
  });

  return {
    ...mutation,
    deleteTaskComment: mutation.mutate,
    deleteTaskCommentAsync: mutation.mutateAsync,
  };
};

export const DELETE_TASK_COMMENTS_MUTATION = DeleteTaskCommentDocument;
